import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from './CancelButton';
import { globalStyles as styles } from './style/gstheme';

class DialogMultiActions extends React.Component {

  render() {

    const { classes, onCancel } = this.props;

    return (
      <DialogActions className={classes.dialogActions} style={{ justifyContent: 'space-between' }}>
        <CancelButton onClick={onCancel} />
        <div>
          <span style={{ marginRight: '10px' }}>
            {this.props.children[0]}
          </span>
          {this.props.children[1]}
        </div>
      </DialogActions>
    );
  }
}

DialogMultiActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  classes: PropTypes.object,
  children: PropTypes.any
};

export default withStyles(styles)(DialogMultiActions);